import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Blocks access to a route/UI tree when a feature flag is disabled.
 *
 * Usage:
 *   <FeatureGate enabled={isCalibrationEnabled()}>
 *     <CalibrationDashboard />
 *   </FeatureGate>
 *
 * When disabled, the user is redirected to `redirectTo` (default: dashboard).
 */
const FeatureGate = ({ enabled, redirectTo = '/', children }) => {
  if (!enabled) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
};

export default FeatureGate;
